import { RichAssetFileUpload, RichAssetPersistentMenu, } from '../../generated/ast.js';
import { RichAssetTypesDisplayNames } from '../../common/mappings.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateNluDisabled(node, nodeFields, accept) {
    const { idField, nextNodesField, nodeTypeField, nluDisabledField, richAssetField, } = nodeFields;
    // If nluDisabledField is not present, then it defaults to false
    const nluDisabled = nluDisabledField?.nluDisabled || 'false';
    // nluDisabled should be false on action nodes
    if (nodeTypeField?.nodeType?.value === 'A' && nluDisabled !== 'false') {
        accept('error', `'nluDisabled' must be set to false on action node '${node?.name}'.`, {
            node: nluDisabledField || node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.NLU_DISABLED,
            },
        });
    }
    if (nodeTypeField?.nodeType?.value === 'D') {
        // nluDisabled must be set to true for certain rich assets
        if (richAssetField &&
            [
                RichAssetPersistentMenu.$type,
                RichAssetFileUpload.$type,
            ].indexOf(richAssetField?.content?.$type) !== -1 &&
            nluDisabled === 'false') {
            accept('error', `'nluDisabled' must be set to true when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
                node: nluDisabledField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.NLU_DISABLED,
                },
            });
        }
        // NLU enabled nodes can only have one item in the nextNodes field
        if (nluDisabled === 'false' &&
            nextNodesField?.nextNodes &&
            nextNodesField?.nextNodes?.length > 1) {
            accept('error', `NLU enabled nodes can only have one next node.`, {
                node: nextNodesField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
                },
            });
        }
        // NLU disabled nodes can only have one child edge node
        if (nluDisabled === 'true') {
            const { childEdgeNodeNumbers } = nodeFields;
            if (childEdgeNodeNumbers.length > 1) {
                accept('error', `NLU disabled nodes can only have one child node.`, {
                    node: nextNodesField || node,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
                    },
                });
            }
        }
    }
}
//# sourceMappingURL=validate-nlu-disabled.js.map